import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_METRIC',
  name: 'Workspace Project Metric',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'monitoringSystem', title: 'Monitoring system' },
    { key: 'utilityUnitOfMeasurement', title: 'Unit of measurement' },
    { key: 'name', title: 'Name' },
    { key: 'metricType', title: 'Metric Type' },
    { key: 'description', title: 'Description' },
    { key: 'measurement', title: 'Measurement' },
  ],
  related: ['WORKSPACE_PROJECT_MEASUREMENT_POINTS', 'WORKSPACE_PROJECT_UTILITY_UNIT_OF_MEASUREMENT'],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
